import { useMemo } from 'react';
import { useGeneralRoutes } from '@namespace/cms';
import { useHistory } from '@namespace/router';

export const useGetMoreInfoAction = ({ messageId, notificationUrl }) => {
  const { push } = useHistory();
  const { messagePreview } = useGeneralRoutes();

  return useMemo(() => {
    if (notificationUrl) {
      const url = new URL(notificationUrl, window.location);
      const isExternal = url.origin !== window.location.origin;

      return () => {
        if (isExternal) {
          window.location = notificationUrl;
        } else {
          push(notificationUrl);
        }
      };
    }

    if (messageId) {
      const url = `${messagePreview}/${messageId}`;

      return () => {
        push(url);
      };
    }

    return null;
  }, [messageId, messagePreview, push, notificationUrl]);
};
